/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs */

const en_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niche prompts become finished designs in bulk, with style presets you control.`)
};

const ar_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برومتات متخصصة تتحول إلى تصاميم جاهزة بكميات، مع أنماط مسبقة تتحكم بها.`)
};

const bn_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিশ প্রম্পট প্রচুর পরিমাণে তৈরি ডিজাইন হয়, আপনার নিয়ন্ত্রণে স্টাইল প্রিসেটসহ।`)
};

const de_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nischen-Prompts werden in Masse zu fertigen Designs, mit Stil-Presets, die Sie kontrollieren.`)
};

const es_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompts de nicho convertidos en diseños acabados en masa, con ajustes de estilo bajo su control.`)
};

const fr_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des prompts de niche deviennent des designs finis en masse, avec des préréglages de style que vous contrôlez.`)
};

const pt_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompts de nicho viram designs acabados em massa, com predefinições de estilo sob o seu controlo.`)
};

const zh_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细分赛道的提示词批量变成成品设计，风格预设由你掌控。`)
};

const tr_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niş istemler topluca bitmiş tasarımlara dönüşür, stil ön ayarları sizin kontrolünüzde.`)
};

const ru_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нишевые промпты массово становятся готовыми дизайнами, со стиль-пресетами под вашим контролем.`)
};

const pl_svc_ai_image_pod_automation_pipeline_desc8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niszowe prompty masowo stają się gotowymi projektami, z presetami stylu pod kontrolą.`)
};

/**
* | output |
* | --- |
* | "Niche prompts become finished designs in bulk, with style presets you control." |
*
* @param {Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_pipeline_desc8 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Pipeline_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_pipeline_desc8(inputs)
	return en_svc_ai_image_pod_automation_pipeline_desc8(inputs)
});
export { svc_ai_image_pod_automation_pipeline_desc8 as "svc_ai-image-pod-automation_PIPELINE_desc" }